import { IconWrapper } from '../runtime';
export default IconWrapper('remark', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M5.75 4.74976H10.25M8.14645 11.3533L12.2879 7.21189C12.405 7.09473 12.595 7.09473 12.7121 7.21189L14.7879 9.28762C14.905 9.40478 14.905 9.59473 14.7879 9.71189L10.6464 13.8533C10.5527 13.9471 10.4255 13.9998 10.2929 13.9998H8.3C8.13431 13.9998 8 13.8654 8 13.6998V11.7069C8 11.5743 8.05268 11.4471 8.14645 11.3533Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M6 14.2498H4.25C3.42157 14.2498 2.75 13.5782 2.75 12.7498V3.24976C2.75 2.42133 3.42157 1.74976 4.25 1.74976H11.75C12.5784 1.74976 13.25 2.42133 13.25 3.24976V5.49976",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});